import React from "react"
import "./index.css"
import Modal from "react-bootstrap/Modal"
import icon from "../../assets/theneworder.svg"
import CardHeader from "../dashboard-card-header"

const SettingsModal = ({ title, children, ...props }) => (
  <Modal centered {...props}>
    <Modal.Header closeButton>
      <CardHeader icon={icon}>{title}</CardHeader>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
  </Modal>
)

export default SettingsModal



// WEBPACK FOOTER //
// ./src/components/settings-modal/SettingsModal.js